import type { FaireProductEntity } from "../../entity_types/product";

export const p_mr7mjjq4xp: FaireProductEntity = {
  token: "p_mr7mjjq4xp",
  type: "product",
  name: "Handmade Ceramic Bowl",
  brandToken: "b_bp2qh0z57y",
  brandName: "Nai Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/82eae39c0b4ae65aaacfd21d7711614f9e640aeb1635095258e64763b167e173.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1b8b0bfd2ed7229e77e2ae3158c85badc9c9f283700de24a2393dbf6174b380.jpeg",
    "https://cdn.faire.com/fastly/57bbb835b6e8e2995fe0ced23160d19b3336127a06968bf518c0571e8996d501.jpeg",
    "https://cdn.faire.com/fastly/56e9fa1bf75f96e45dc1c255bc999dc60502593ac928b362af197e4b1055010a.jpeg",
    "https://cdn.faire.com/fastly/90f4d08e8d598906c44acd22e64de061db5a42df43a4d2fdd29863ac80886122.jpeg",
    "https://cdn.faire.com/fastly/2df1ba6bdbdc684723c9f5535a223133f77cf3d7d7430d4c2b792904b6828aff.jpeg",
    "https://cdn.faire.com/fastly/00464ba6fb00340c884ba8e82c7c32a1e45b6ec55f9bf9a5f68f76788d30bb21.jpeg",
  ],
  priceDollars: 6.03,
  description:
    "Elevate your snacking experience with this exquisite handmade ceramic bowls.Each unique piece showcases vibrant glazes and intricate design .Perfect for serving nuts,chips or dips.Ideal for gatherings and home decor \nHand wash \nLead free\n",
  tags: [],
  msrpDollars: 12.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:18.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
